import { Box as ChakraBox, type BoxProps as ChakraBoxProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraBoxProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <ChakraBox ref={ref} {...props} />
})